import { useInfiniteQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

import type { operations } from '@/schema'

type GetBannedRoomsParams =
	operations['ChatController_getBannedRooms']['parameters']['query']

export function useQueryBannedRooms(
	params?: Omit<GetBannedRoomsParams, 'start'>,
) {
	return useInfiniteQuery({
		queryKey: chatKeys.bannedRooms(params),
		queryFn: ({ pageParam }) =>
			chatService.getBannedRooms({
				...params,
				start: pageParam,
			}),
		initialPageParam: undefined as string | undefined,
		getNextPageParam: (lastPage) =>
			lastPage.pagination.hasMore ? lastPage.pagination.nextCursor : undefined,
	})
}
